import type { IconName } from '@sweetgreen/garnish';

import type { CardType } from '../graphql/types';

type Index = CardType | 'NEW';
export const CREDIT_CARDS_ICONS: Record<Index, IconName> = {
  VISA: 'IconCcVisa',
  MASTER_CARD: 'IconCcMasterCard',
  DISCOVER: 'IconCcDiscover',
  AMEX: 'IconCcAmex',
  AMERICAN_EXPRESS: 'IconCcAmex',
  NEW: 'IconCreditCard',
};
